export enum Events {
    SUCCESS_FORM_SUBMIT = 'successful_form_submit',
    GENERATE_LEAD = 'generate_lead',
    START_FORM = 'form_start',
    PAGE_META_DATA = 'pageMetaData', //I tried making the naming consistent but they wouldn't allow me to
    API = 'api',
}
